import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'deelnemers',
    templateUrl: 'deelnemers.html'
})
export class Deelnemers implements OnInit {
    constructor() { }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/pages/deelnemers/deelnemers.ts